// src/web/insights/InsightsList.jsx 

import { useMemo } from "react";
import { insights } from "../../content/insights";
import InsightCard from "../../components/insights/InsightCard";
import { Link } from "react-router-dom";
import PageTracker from '../../components/tracking/PageTracker';
import ScrollTracker from '../../components/tracking/ScrollTracker';

function InsightsList() {

  const sorted = useMemo(() => {
    return [...insights].sort(
      (a, b) => new Date(b.meta.publishedAt) - new Date(a.meta.publishedAt)
    );
  }, []);

  const [hero, second, third, ...rest] = sorted;

  return (
    <div className="insights-container">
      <PageTracker pageName="InsightsList" />

      {/* HEADER */}
      <header className="insights-header">
        <h1 className="insights-title">Insights</h1>

        <p className="insights-description">
          A curated space exploring perceptual voice evaluation as infrastructure — across research, education, clinical practice, and human-centered AI.

          <br /><br />
          From methodological reflections and educational resources to ecosystem development and perceptual infrastructure thinking, this section documents how listening becomes structured knowledge at scale.
        </p>
      </header>

      {/* HERO */}
      {hero && (
        <Link to={`/insights/${hero.slug}`} className="insight-hero insights-hero">

          <div className="insight-hero-content">
            <div className="insight-card-meta">
              {hero.meta.category} · {hero.meta.date}
            </div>

            <h2 className="insight-hero-title">
              {hero.meta.title}
            </h2>

            <p className="insight-hero-excerpt">
              {hero.meta.excerpt}
            </p>
            
            <p className="insight-hero-readmore">
              Read article →
            </p>
          </div>

          <img src={hero.meta.coverImage} alt={hero.meta.title} />

        </Link>
      )}

      {/* SECONDARY */}
      <div className="insights-secondary">
        {[second, third].filter(Boolean).map(article => (
          <Link
            key={article.slug}
            to={`/insights/${article.slug}`}
            className="insight-card insight-card-compact"
          >
            <img src={article.meta.coverImage} alt={article.meta.title} />

            <div className="insight-card-meta">
              {article.meta.category}
            </div>

            <h3 className="insight-card-title">
              {article.meta.title}
            </h3>
          </Link>
        ))}
      </div>

      {/* GRID */}
      <div className="insight-grid">
        {rest.map(article => (
          <InsightCard key={article.slug} article={article} />
        ))}
      </div>
      <ScrollTracker pageName="InsightsList" />
    </div>
  );
}

export default InsightsList;